import styled, { css } from 'styled-components';

export const BlankWrapper = styled.div<{ caption: any }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  max-width: 1800px;
  min-width: 285px;
  width: 100%;
  background: ${(props) => (props.caption === 'oneCar' ? '#F4F8FA;' : '#ffffff;')}
  padding: 44px 0 48px 0;

  @media (min-width: 590px) {
    padding: 64px 0 48px 0;    
  }
`;
export const BlankHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #183558;
  width: 100%;
`;
export const BlankHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  align-items: center;
  justify-content: center;
  background: #183558;
  padding: 80px 20px 80px 20px;
  @media (min-width: 768px) {
    padding: 56px 32px 58px 32px;
  }
`;
export const BlankButtonCta = styled.button`
  display: flex;
  width: 216px;
  justify-content: center;
  align-items: flex-start;
  display: flex;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 3px;
  border: 0;
  background: var(--Primary-Blue-2, #00aed9);
  color: var(--Neutral-White, #fff);
  text-align: center;
  font-feature-settings: 'cpsp' on, 'liga' off;

  /* Label/M */
  font-family: 'Brandon Text';
  font-size: 14px;
  font-style: normal;
  font-weight: 450;
  line-height: 16px; /* 114.286% */
  text-transform: uppercase;

  &:hover {
    background: var(--cvna-color-blue-3);
    color: var(--cvna-color-white);
  }
`;
export const BlankCaption = styled.div`
  min-width: 272px;
  max-width: 272px;
  width: 100%;
  // height: 28px;
  margin: 0 auto;
  color: #ffffff;
  font-family: 'Brandon Text';
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  line-height: 28px;
  text-align: center;
  font-feature-settings: 'liga' off;

  @media (min-width: 320px) {
    max-width: 311px;
  }
  @media (min-width: 375px) {
    font-size: 18px;
    line-height: 28px;
    max-width: 775px;
  }
`;
export const BlankCaptionLarge = styled.div`
  min-width: 311px;
  max-width: 272px;
  width: 100%;
  margin: 4px 20px 16px 20px;
  color: #ffffff;
  font-family: 'Brandon Text';
  font-style: normal;
  font-weight: bold;
  font-size: 40px;
  line-height: 40px;
  text-align: center;
  font-feature-settings: 'cpsp' on, 'liga' off;
  text-transform: uppercase;

  @media (min-width: 320px) {
    max-width: 311px;
  }
  @media (min-width: 375px) {
    margin: 8px 32px 16px 32px;
    font-size: 54px;
    line-height: 54px;
    max-width: 775px;
  }
  @media (min-width: 768px) {
    font-size: 72px;
    line-height: 72px;
  }
`;
export const PipBlankCaption = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  padding: 48px 30px 0 30px;
  color: #183558;
  font-family: 'Brandon Text';
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  margin: 0 auto;
  font-feature-settings: 'cpsp' on, 'liga' off;
  background: #f4f8fa;

  @media (min-width: 590px) {
    padding-top: 65px;
    font-size: 28px;
    line-height: 32px;
    width: 100%;
  }
  @media (min-width: 768px) {
    font-size: 40px;
    line-height: 44px;
    padding-top: 88px;
  }
`;
export const BlankTitle = styled.div`
  min-width: 272px;
  max-width: 272px;
  margin: 0 auto;
  color: #ffffff;
  font-family: 'Brandon Text';
  font-weight: bold;
  font-style: normal;
  font-size: 18px;
  line-height: 28px;
  text-align: center;
  font-feature-settings: 'liga' off;
  text-transform: uppercase;

  @media (min-width: 321px) {
    max-width: 311px;
  }
  @media (min-width: 375px) {
    font-size: 18px;
    line-height: 28px;
    max-width: 775px;
  }
`;
export const BlankRowOneWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin: 0 auto 70px auto;
  padding: 0 10px;
  max-width: 1440px;
  width: 100%;

  @media (min-width: 320px) {
    padding: 0 30px;
  }
  @media (min-width: 590px) {
    margin: 0 auto 40px auto;
    padding: 0;
    flex-wrap: nowrap;
  }
`;
export const BlankOneImageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;

  @media (min-width: 590px) {
    width: 52%;
  }
  @media (min-width: 768px) {
    width: 58%;
  }
`;
export const BlankOneImage = styled.img`
  display: none;

  @media (min-width: 768px) {
    display: flex;
    margin-bottom: 16px;
    max-width: 670px;
    width: 100%;
  }
`;
export const BlankOneImageMobile = styled.img`
  display: flex;
  max-width: 360px;
  width: 100%;

  @media (min-width: 590px) {
    max-width: 300px;
  }
  @media (min-width: 768px) {
    display: none;
  }
`;
export const BlankOneTextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  @media (min-width: 590px) {
    width: 42%;
    padding-right: 30px;
    justify-content: flex-start;
  }
`;
export const BlankOneText = styled.div`
  max-width: 269px;
  width: 100%;
  color: #183558;
  font-family: 'Brandon Text';
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  font-feature-settings: 'liga' off;

  @media (min-width: 590px) {
    text-align: left;
    min-width: 250px;
    max-width: 277px;
  }
  @media (min-width: 768px) {
    max-width: 448px;
  }
`;
export const BlankOneTextBold = styled.div`
  max-width: 269px;
  width: 100%;
  margin: 24px auto 16px auto;
  color: #183558;
  font-family: 'Brandon Text';
  font-weight: bold;
  font-style: normal;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  font-feature-settings: 'liga' off;

  @media (min-width: 590px) {
    text-align: left;
    max-width: 277px;
  }

  @media (min-width: 768px) {
    font-size: 28px;
    line-height: 32px;
    max-width: 448px;
    margin-bottom: 8px;
  }
`;
export const BlankRowTwoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding: 0 30px;
  max-width: 1440px;
  width: 100%;

  @media (min-width: 590px) {
    padding: 0;
    flex-wrap: nowrap;
  }
`;
export const BlankTwoImageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  order: -1;

  @media (min-width: 590px) {
    order: 99;
    width: 50%;
    padding-left: 30px;
    justify-content: flex-start;
  }
  @media (min-width: 768px) {
    justify-content: center;
    width: 58%;
  }
`;
export const BlankTwoImage = styled.img`
  display: none;

  @media (min-width: 768px) {
    display: flex;
    margin-bottom: 16px;
    max-width: 670px;
    width: 100%;
  }
`;
export const BlankTwoImageMobile = styled.img`
  display: flex;
  max-width: 360px;
  width: 100%;

  @media (min-width: 590px) {
    max-width: 300px;
  }
  @media (min-width: 768px) {
    display: none;
  }
`;
export const BlankTwoTextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  @media (min-width: 590px) {
    width: 42%;
    padding-left: 90px;
    justify-content: flex-end;
  }
`;
export const BlankTwoText = styled.div`
  max-width: 269px;
  width: 100%;
  color: #183558;
  font-family: 'Brandon Text';
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  font-feature-settings: 'liga' off;

  @media (min-width: 590px) {
    min-width: 250px;
    max-width: 270px;
    text-align: left;
  }
  @media (min-width: 768px) {
    max-width: 448px;
  }
`;
export const BlankTwoTextBold = styled.div`
  max-width: 269px;
  width: 100%;
  margin: 24px auto 16px auto;
  color: #183558;
  font-family: 'Brandon Text';
  font-weight: bold;
  font-style: normal;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  font-feature-settings: 'liga' off;

  @media (min-width: 590px) {
    text-align: left;
    max-width: 248px;
  }
  @media (min-width: 768px) {
    font-size: 28px;
    line-height: 32px;
    max-width: 448px;
    margin-bottom: 8px;
  }
`;
